module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "w3-main main-container"
  }, [_c('page-header'), _vm._v(" "), _c('div', {
    staticClass: "w3-container about-container"
  }, [_c('h1', {
    staticClass: "w3-xxxlarge"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('References')))])]), _vm._v(" "), _c('hr', {
    staticClass: "w3-round"
  }), _vm._v(" "), _c('gallery', {
    attrs: {
      "images": _vm.galleryImages,
      "index": _vm.galleryIndex,
      "options": {
        displayClass: 'blueimp-gallery-display-fix'
      }
    },
    on: {
      "close": function($event) {
        _vm.galleryIndex = null
      }
    }
  }), _vm._v(" "), (_vm.folderId) ? _c('router-link', {
    attrs: {
      "to": "/referenciak"
    }
  }, [_c('button', {
    staticClass: "w3-button w3-block w3-padding-large w3-pink w3-margin-bottom"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('Back to references')) + "\n      ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "items-images-container"
  }, _vm._l((_vm.folder.filter(function (ref) {
    var isFolder = ref.isFolder;

    return isFolder;
  })), function(item) {
    return _c('reference-item', {
      key: item.id,
      attrs: {
        "item": item,
        "gApiKey": _vm.gApiKey
      },
      on: {
        "error": _vm.handleError
      }
    })
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "items-images-container"
  }, _vm._l((_vm.folder.filter(function (ref) {
    var isFolder = ref.isFolder;

    return !isFolder;
  })), function(item, index) {
    return _c('reference-item', {
      key: item.id,
      attrs: {
        "item": item,
        "gApiKey": _vm.gApiKey
      },
      on: {
        "click": function($event) {
          _vm.galleryIndex = index
        },
        "error": _vm.handleError
      }
    })
  }), 1), _vm._v(" "), (_vm.folderId) ? _c('router-link', {
    attrs: {
      "to": "/referenciak"
    }
  }, [_c('button', {
    staticClass: "w3-button w3-block w3-padding-large w3-pink w3-margin-bottom"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('Back to references')) + "\n      ")])]) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3e3df5d5","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/References.vue
// module id = 940
// module chunks = 0